import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./master.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
